module.exports = __webpack_public_path__ + "static/media/articlesList-bg-shape.709d80e9.svg";